import type { ReactNode } from 'react'
import { Badge } from '~/components/ui/badge'
import { scaleLabel } from '~/components/assessment/labels'
import type { AssessmentResponse } from '~/api/types'
import { assessmentStatusLabel, formatDateTime } from './utils'

export function AssessmentOptionCard({
    assessment,
    selected,
    onSelect,
}: {
    assessment: AssessmentResponse
    selected: boolean
    onSelect(value: string): void
}) {
    const score =
        typeof assessment.totalScore === 'number' &&
        typeof assessment.maxScore === 'number'
            ? `${assessment.totalScore}/${assessment.maxScore}점`
            : '채점 전'

    return (
        <button
            type='button'
            onClick={() => onSelect(assessment.id)}
            aria-pressed={selected}
            className={`border-border bg-card hover:border-primary min-w-0 rounded-md border p-5 text-left shadow-sm transition-colors ${
                selected ? 'border-primary bg-accent' : ''
            }`}>
            <div className='flex flex-wrap items-start justify-between gap-3'>
                <div className='min-w-0'>
                    <p className='text-muted-foreground text-xs font-bold'>
                        {assessment.classification ?? '분류 미정'} ·{' '}
                        {scaleLabel(assessment.scale)}
                    </p>
                    <h3 className='text-foreground mt-2 text-lg font-bold'>
                        {assessment.title}
                    </h3>
                </div>
                <Badge tone={selected ? 'info' : 'neutral'}>
                    {selected
                        ? '선택됨'
                        : assessmentStatusLabel(assessment.status)}
                </Badge>
            </div>

            <dl className='mt-4 grid gap-2 text-sm'>
                <AssessmentMetaRow label='업종'>
                    {assessment.industry ?? '업종 미정'}
                </AssessmentMetaRow>
                <AssessmentMetaRow label='점수'>{score}</AssessmentMetaRow>
                <AssessmentMetaRow label='시작'>
                    {formatDateTime(assessment.createdAt)}
                </AssessmentMetaRow>
                <AssessmentMetaRow label='최근 수정'>
                    {formatDateTime(assessment.updatedAt)}
                </AssessmentMetaRow>
            </dl>
        </button>
    )
}

function AssessmentMetaRow({
    label,
    children,
}: {
    label: string
    children: ReactNode
}) {
    return (
        <div className='grid grid-cols-[72px_minmax(0,1fr)] gap-3'>
            <dt className='text-muted-foreground'>{label}</dt>
            <dd className='text-foreground font-medium'>{children}</dd>
        </div>
    )
}
